import {
  Component, OnInit, HostListener,
  ViewChild, AfterViewInit, SecurityContext,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { ClipboardService } from 'ngx-clipboard';

import { Subject, Observable } from 'rxjs';
import { fromEvent } from 'rxjs';


import {
  ApplicationState, State, getApplicationState,
  ToastUserNotification, EngineeringDrawingDetail, OpenEngDrawing
} from 'src/app/state-management';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil, map } from 'rxjs/operators';

import {
  FilterSettingsModel, GridComponent, SelectionSettingsModel,
  RowSelectEventArgs, RowDeselectEventArgs, ColumnModel
} from '@syncfusion/ej2-angular-grids';
import { setSpinner } from '@syncfusion/ej2-angular-popups';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import * as jszip from 'jszip';
const JSZip = require('jszip');
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-eng-drawings',
  templateUrl: './eng-drawings.component.html',
  styleUrls: ['./eng-drawings.component.scss'],
  standalone: false
})
export class EngDrawingsComponent implements OnInit, AfterViewInit, OnDestroy {

  application$: Observable<ApplicationState>;
  applicationState: ApplicationState;

  private ngUnsubscribe: Subject<void> = new Subject();
  public drawings: EngineeringDrawingDetail[] = [];
  public columns: ColumnModel[] = [];
  public filterOption: FilterSettingsModel = { type: 'Excel' };
  public selectionOptions: SelectionSettingsModel = { mode: 'Row', type: 'Multiple', enableSimpleMultiRowSelection: true };
  public selectedDrawingUrl: string; // SafeResourceUrl | null = null;
  public headerHeight = 54;
  public drawingHeight = 0;
  public gridHeight = 0;
  public gridWidth = 0;
  public isDesktop = false;
  public isDesktopBoundary = 767;
  target: any;

  // divider state
  // a full page modal is shown while moving the divider, otherwise the mouse move events are lost over the pdf
  // finally, a delay in showing the modal is introduced to allow double click events to be capbured on the divider
  mousedown$: any;
  mousedownSubscription: any;
  clicked = false;
  doubleClicked = false;
  movingDivider = false;
  showFullpageModal = false;
  isSensitive = false;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('projectName') public projectNameTemplate: any;
  @ViewChild('docNum') public docNumTemplate: any;

  @ViewChild('divider', { static: false }) public divider: ElementRef<any>;
  @ViewChild('pdfViewer') public pdfViewer: PdfJsViewerComponent;

  constructor(
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient, // for demo purpose, should not be here
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<State>,
    private clipboardService: ClipboardService
  ) {
    this.application$ = this.store.select(getApplicationState);
  }

  setColumns(): void {

    this.columns = this.tableColumnsMeta().map((meta: ColumnModel) => {
      return {
        field: meta.field,
        headerText: meta.headerText,
        width: 'auto',
        clipMode: 'EllipsisWithTooltip',
        textAlign: 'Left',
        minWidth: meta.minWidth,
        maxWidth: meta.maxWidth,
        visible: meta.visible,
        template: meta.template
      };
    });

  }

  nbOfDrawingSelected(): number {
    if (this.grid) {
      return this.grid.getSelectedRowIndexes().length;
    }
    return 0;
  }

  singleDrawingSelected(): boolean {
    if (this.grid) {
      //return (null || undefined) !== this.selectedDrawingUrl;
      return (null !== this.selectedDrawingUrl || undefined !== this.selectedDrawingUrl);
    }
    return false;
  }

  isDrawingSelected(): boolean {
    if (this.grid) {
      return this.nbOfDrawingSelected() > 0;
    }
    return false;
  }

  rowSelected(args: RowSelectEventArgs): void {
    if (args.target.classList.contains('no-select')) {
      (args as any).cancel = true;
    }
  }

  rowDeSelected(args: RowDeselectEventArgs): void {
    if (args.target.classList.contains('no-select')) {
      (args as any).cancel = true;
    }
  }

  toggleSelecting(args: RowSelectEventArgs | RowDeselectEventArgs): void {
    if (args.target.classList.contains('no-select')) {
      (args as any).cancel = true;
      const data: EngineeringDrawingDetail = args.data as EngineeringDrawingDetail;
      if (data && data.url) {
        if (this.isDesktop) {
          this.selectedDrawingUrl = data.url; // this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
          if (this.pdfViewer) {
            this.pdfViewer.pdfSrc = this.selectedDrawingUrl;
            this.pdfViewer.refresh();
          }
        } else {
          const url = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL,
            this.sanitizer.bypassSecurityTrustResourceUrl(data.url)
          );
          this.store.dispatch(new OpenEngDrawing(url));
        }
        if (data.sensitive) {
          this.isSensitive = true;
        } else {
          this.isSensitive = false;
        }
      }

    }
  }

  rowBound(e: any): void {
    if (e.data.sensitive) {
      e.row.classList.add('sensitive');
    }
  }

  drawingFrameMessage(): string {
    return 'Click on drawing number to view.';
  }

  tableColumnsMeta(): ColumnModel[] {

    // ['date', 'number', 'type', 'includedInfrastructure', 'sensitive', 'url']
    return [
      {
        field: 'date',
        headerText: 'Date',
        minWidth: 50,
        maxWidth: 100,
        visible: true
      },
      {
        field: 'number',
        headerText: 'Number',
        minWidth: 100,
        maxWidth: 200,
        visible: true,
        template: this.docNumTemplate,
      },
      {
        field: 'type',
        headerText: 'Type',
        minWidth: 150,
        maxWidth: 300,
        visible: true
      },
      {
        field: 'includedInfrastructure',
        headerText: 'Infrastructure',
        minWidth: 150,
        maxWidth: 300,
        visible: true
      },
      /*  {
          field: 'sensitive',
          headerText: 'Sensitive',
          minWidth: 50,
          maxWidth: 100,
          visible: true
        }, */
      {
        headerText: 'Project',
        field: 'projectName',
        template: this.projectNameTemplate,
        minWidth: 150,
        maxWidth: 300,
        visible: true,
      }
    ];
  }

  copyUrlsToClipboard(): void {
    if (this.grid) {
      const urls = this.grid.getSelectedRowIndexes().sort().map(index => (this.grid.currentViewData[index] as EngineeringDrawingDetail).url).join('\r\n');
      this.clipboardService.copyFromContent(urls);

      this.store.dispatch(new ToastUserNotification({
        type: 'success',
        title: 'Drawing(s) URL Copied to Clipboard',
        message: '',
        options: {}
      }));

    }
  }

  ngOnInit(): void {

    this.application$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: ApplicationState) => {
      this.applicationState = state;
      this.setHeaderHeight();
      this.adjustGridWidth(true);
    });

    if (this.route.snapshot && this.route.snapshot.params) {

      const listOfDrawingsKey = 'numbers';
      const aocCoordKey = 'areaOfInterest';
      const projName = 'projectName';
      const projType = 'type';
      const listOfDrawings: string = this.route.snapshot.params[listOfDrawingsKey]; // https://localhost:44308/engdrawings;numbers=dwg1,dwg2
      const aocCoord: string = this.route.snapshot.params[aocCoordKey]; // https://localhost:44308/engdrawings;areaOfInterest=%5B0,1,2,3%5D
      const projectName = this.route.snapshot.params[projName];
      const projectType = this.route.snapshot.params[projType];
      if (listOfDrawings) {

        // TODO move this to an effect
        if (projectType) {
          this.httpClient.get('api/engdrawings?numbers=' + listOfDrawings + '&type=' + projectType).toPromise()
            .then((drawings: EngineeringDrawingDetail[]) => {
              this.setColumns();
              this.drawings = drawings;
              if (drawings.length === 1) {
                this.selectedDrawingUrl = this.drawings[0].url; // this.sanitizer.bypassSecurityTrustResourceUrl(this.drawings[0].url);
                if (this.pdfViewer) {
                  this.pdfViewer.pdfSrc = this.selectedDrawingUrl;
                  this.pdfViewer.refresh();
                }
                if (this.drawings[0].sensitive) {
                  this.isSensitive = true;
                } else {
                  this.isSensitive = false;
                }
              }
            });
        } else {
          this.httpClient.get('api/engdrawings?numbers=' + listOfDrawings).toPromise()
            .then((drawings: EngineeringDrawingDetail[]) => {
              this.setColumns();
              this.drawings = drawings;
              if (drawings.length === 1) {
                this.selectedDrawingUrl = this.drawings[0].url; // this.sanitizer.bypassSecurityTrustResourceUrl(this.drawings[0].url);
                if (this.pdfViewer) {
                  this.pdfViewer.pdfSrc = this.selectedDrawingUrl;
                  this.pdfViewer.refresh();
                }
                if (this.drawings[0].sensitive) {
                  this.isSensitive = true;
                } else {
                  this.isSensitive = false;
                }
              }
            });
        }


      } else if (aocCoord) {

        // TODO move this to an effect
        this.httpClient.get('api/engdrawings?areaOfInterest=' + aocCoord).toPromise()
          .then((drawings: EngineeringDrawingDetail[]) => {
            this.setColumns();
            this.drawings = drawings;
          });
      } else if (projectName) {
        this.httpClient.get('api/engdrawings?projectName=' + projectName).toPromise()
          .then((drawings: EngineeringDrawingDetail[]) => {
            this.setColumns();
            this.drawings = drawings;
          });
      }
      else {
        this.store.dispatch(
          new ToastUserNotification({
            type: 'fail',
            title: 'Engineering Drawings',
            message: 'You need to provide either: drawing numbers or an areaOfInterest.',
            options: {
              disableTimeOut: true,
              closeButton: true
            }
          })
        );

      }

    }

    if (this.drawingHeight === 0) {
      this.setHeaderHeight();
    }

    this.adjustGridWidth();

  }

  ngAfterViewInit(): void {

    if (this.applicationState.windowInnerWidth > this.isDesktopBoundary) {
      this.isDesktop = true;
    }

    // Listen for a mouse down event on the divider to start moving it
    this.mousedown$ = fromEvent(this.divider.nativeElement, 'mousedown');
    this.mousedownSubscription = this.mousedown$
      .subscribe((e: any) => {
        this.movingDivider = true;

        setTimeout(() => {
          if (this.doubleClicked || this.clicked) {
            this.clicked = false;
            this.movingDivider = false;
            this.showFullpageModal = false;
          } else {
            this.showFullpageModal = true;
          }
        }, 650);

      })

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // Demo interceptor - obtain user profile
  getProfile(): void {
    // this.httpClient.get(this.graphMeEndpoint).toPromise()
    //   .then((profile: UserProfile) => {
    //     this.userProfile = profile;
    //     this.userIcon = profile.givenName.substring(0, 1).toUpperCase() + profile.surname.substring(0, 1).toUpperCase();
    //   });

    // // this.httpClient.get('https://localhost:44308/api/user/info').toPromise()
    // //   .then((data: any) => {
    // //     console.log(data);
    // //   });
  }

  logout(): void {
    this.router.navigate(['/logout']);
  }


  clearFullpageModal() {
    this.movingDivider = false;
    this.showFullpageModal = false;
  }

  handlerClick() {
    this.clicked = true;
    this.movingDivider = false;
    this.showFullpageModal = false;
  }

  doubleClick() {
    this.doubleClicked = true;

    if (this.gridWidth > 0) {
      this.gridWidth = 0;
    } else {
      this.adjustGridWidth();

      this.unselectText();
    }

    setTimeout(() => {
      this.doubleClicked = false;
      this.movingDivider = false;
      this.showFullpageModal = false;
    }, 1000);
  }

  unselectText(): void {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: any): void {
    if (this.movingDivider) {
      this.gridWidth = Math.max(0, event.x - 10);
      this.unselectText();
    }
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: any): void {
    if (this.movingDivider) {
      this.movingDivider = false;
      this.showFullpageModal = false;

      this.unselectText();
    }
  }

  setHeaderHeight(): void {
    this.drawingHeight = this.applicationState.windowInnerHeight - this.headerHeight;
    this.gridHeight = this.drawingHeight - 50;
  }

  // if the user has collapsed the grid and resize, don't re-open it during resize
  adjustGridWidth(onResize: boolean = false): void {
    // Leave 10px for the divider
    if (this.applicationState.windowInnerWidth < this.isDesktopBoundary && !(0 === this.gridWidth && onResize)) {
      this.gridWidth = this.applicationState.windowInnerWidth;
    } else {
      if (0 === this.gridWidth && !onResize) {
        this.gridWidth = this.applicationState.windowInnerWidth / 2 - 10;
      }
    }
  }

  downloadFile() {
    const urls = this.grid.getSelectedRowIndexes().sort().map(index => (this.grid.currentViewData[index] as EngineeringDrawingDetail).url);

    let timestamp = '';
    if (urls.length > 1) {
      const today = new Date(Date.now());
      const monPart = this.formatTimePart(today.getMonth() + 1);
      const datePart = this.formatTimePart(today.getDate());
      const hrPart = this.formatTimePart(today.getHours());
      const minPart = this.formatTimePart(today.getMinutes());
      const secsPart = this.formatTimePart(today.getSeconds());
      timestamp = today.getFullYear() + monPart.toString() + datePart.toString() + '-' + hrPart.toString() + minPart.toString() + secsPart.toString();
    }

    const fileName = 'eng-drawings-' + timestamp + '.zip';
    this.saveToZip(fileName, urls);
  }

  formatTimePart(datePart: number) {
    if (datePart < 10) {
      return '0' + datePart;
    }

    return datePart;
  }

  saveToZip(filename: any, urls: any) {
    if (urls.length > 1) {
      const zip = new JSZip();

      urls.forEach((url: any) => {
        const blobPromise = fetch(url).then(r => {
          if (r.status === 200) return r.blob()
          return Promise.reject(new Error(r.statusText));
        })
        const name = url.substring(url.lastIndexOf('/') + 1);
        zip.file(name, blobPromise);
      })

      zip.generateAsync({ type: "blob" })
        .then((blob: any) => saveAs(blob, filename))
        .catch((e: any) => console.log(e));
    } else {
      const name = urls[0].substring(urls[0].lastIndexOf('/') + 1);
      saveAs(urls[0], name);
    }

  }

  public gridCreated(): void {
    setSpinner({ type: 'Bootstrap' });
    this.grid.showSpinner();
  }
}
